export const ownerTypeOptions = ['Individuals', 'Proprietorship', 'LLC', 'Corporation'];

export const currentUsage = ['Vacant', 'Retail', 'Office', 'Multi-Family'];

export const zoaning = [
  'MXD',
  'E-1 ',
  'R-1',
  'R-2',
  'R-3',
  'R-4',
  'R-4A',
  'R-5',
  'R-6',
  'R-7',
  'R-8',
  'B-1',
  'B-2',
  'B-3',
  'B-4',
  'B-5',
  'B-6',
  'O&I',
  'PRD',
  'M-1',
  'M-1A',
  'M-2',
  'M-3',
  'M-4',
  'A-1',
  'A-2',
];
